<div class="event-info">
    <div class="event-image">
        <ng-container *ngIf="!isLoading">
            <img *ngIf="event.backgroundImageUrl" [src]="event.backgroundImageUrl" />
            <img *ngIf="!event.backgroundImageUrl" src="/Content/Images/emptyEvent.webp?width=200" alt="" />
        </ng-container>
        <app-skeleton *ngIf="isLoading"/>
    </div>
    <div class="event-body">
        <div class="event-item-top">
            <div class="date-item">
                <div *ngIf="!isLoading" class="date" [class.date--range]="!isSameMonthYear">
                    <!-- One day -->
                    <ng-container *ngIf="isSameDay">
                        <div class="day">{{ event.startDate | date: 'dd' }}</div>
                        <div class="month">{{ event.startDate | date: 'MMM' }} {{ event.startDate | date: 'yyyy' }}</div>
                    </ng-container>
                    <!-- Several days, same month and year -->
                    <ng-container *ngIf="!isSameDay && isSameMonthYear">
                        <div class="day">{{ event.startDate | date: 'dd' }} - {{ event.endDate | date: 'dd' }}</div>
                        <div class="month">{{ event.startDate | date: 'MMM' }} {{ event.startDate | date: 'yyyy' }}</div>
                    </ng-container>
                    <!-- Several days across months/years -->
                    <ng-container *ngIf="!isSameDay && !isSameMonthYear">
                        <div class="date-range-item">
                            <div class="day">{{ event.startDate | date: 'dd' }}</div>
                            <div class="month">{{ event.startDate | date: 'MMM' }} {{ event.startDate | date: 'yyyy' }}</div>
                        </div>
                        <div class="date-range-sep">-</div>
                        <div class="date-range-item">
                            <div class="day">{{ event.endDate | date: 'dd' }}</div>
                            <div class="month">{{ event.endDate | date: 'MMM' }} {{ event.endDate | date: 'yyyy' }}</div>
                        </div>
                    </ng-container>
                </div>
                <div *ngIf="isLoading" class="date skeleton">
                    <app-skeleton [height]="66"/>
                </div>
                <div *ngIf="!isLoading" class="date-name">
                    {{atHourText}} {{ event.startDate | date: 'HH:mm':'UTC' }} 
                    <br>
                    {{ event.location }}
                </div>
                <div *ngIf="isLoading" class="date-name">
                    <app-skeleton [type]="'text'" [symbolsCount]="9"/><br><app-skeleton [type]="'text'" [symbolsCount]="18"/>
                </div>
            </div>
            <div *ngIf="!isLoading" class="event-item-top-left">
                <div *ngIf="event.freeEvent" class="label-item">
                    {{freeEventText}}
                </div>
                <div *ngIf="event.onlineEvent" class="label-item">
                    {{onlineEventText}}
                </div>
                <div *ngIf="socialShareSettings && event.shareUs.socialNetworks && event.shareUs.socialNetworks.length" class="social-media-share-btn">
                    <app-social-networks-share-button 
                        [socialShareSettings]="socialShareSettings" 
                        [socialNetworksLinks]="event.shareUs.socialNetworks"
                        [eventUrl]="event.url"
                        />
                </div>
            </div>
        </div>
        
        <div *ngIf="isLoading" class="event-item-bottom">
            <div class="event-item-bottom-right">
                <h3><app-skeleton class="event-item-name" [type]="'text'" [symbolsCount]="50"/></h3>
                <app-skeleton class="event-item-sub" [type]="'text'" [symbolsCount]="70"/>
            </div>
            <div class="event-item-buttons">
                <div *ngFor="let _ of [].constructor(2)" class="registration-event-btn">
                    <app-skeleton />
                </div>
            </div>
        </div>

        <div *ngIf="!isLoading" class="event-item-bottom">
            <div class="event-item-bottom-right">
                <h3><a href="{{event.url}}" class="event-item-name" target="_blank">{{ event.pageTitle }}</a></h3>
                <div class="event-item-sub">{{ event.shortDescription }}</div>
            </div>
            <div class="event-item-buttons">
                <app-share-button 
                    *ngIf="shareCalendarIcons" 
                    class="share-events-lobby-button"
                    [btnText]="addToDiaryBtnText" 
                    [links]="shareCalendarIcons" 
                    (addToCalendarClick)="addToCalendarClick($event)"
                ></app-share-button>
                <a *ngIf="event.registrationLinkUrl && !event.registrationEventForm" href="{{event.registrationLinkUrl}}" mat-flat-button color="primary" class="registration-event-btn" target="_blank">
                    {{registrationEventText}}
                </a>
                <a *ngIf="event.registrationEventForm" mat-flat-button color="primary" class="registration-event-btn" (click)="openRegistrationForm($event)">
                    {{registrationEventText}}
                </a>
            </div>
        </div>
    </div>
</div>